export default "__VITE_ASSET__BQlxEgrX__"